import * as React from 'react';
import styled from 'styled-components';
import {Button} from 'epic-ue-components';
import {SectionProps} from 'epic-ue-shared';
import {StyledTypography} from '../Sdk.styles';

export const StyledSuccessSection = styled.section<{backgroundSrc?: string}>`
    height: 475px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-image: url(${p => p.backgroundSrc});
    background-size: cover;
`;

const TextBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 32px;
    max-width: 681px;
    padding: 16px;
`;

const SuccessSection: React.FC<SectionProps> = props => {
    if (!props) return null;

    return (
        <StyledSuccessSection backgroundSrc={props.media?.image}>
            <TextBlock>
                <StyledTypography fontSize={40} fontWeight={500} lineHeight={42} textAlign="center" customColor="#FFF">
                    {props.title}
                </StyledTypography>
                <StyledTypography fontSize={18} fontWeight={400} lineHeight={26} textAlign="center" customColor="#FFF">
                    {props.desc}
                </StyledTypography>
            </TextBlock>

            {/** Considered to be only one button, styles for several are undefined */}
            {props.buttons.map(({label, href}, i) => (
                <Button type="secondary" key={i} href={href} target="_blank">
                    {label}
                </Button>
            ))}
        </StyledSuccessSection>
    );
};

export default SuccessSection;
